import { useState } from 'react';
import reduce from 'lodash/reduce';
import merge from 'lodash/merge';
import get from 'lodash/get';

export const getQuarterList = arrayLength => {
    const quarterArrLength = arrayLength || 5;
    const noOfMonthsInQuarter = 3;
    function getQuarter() {
        const date = new Date();
        const q1 = 1;
        const q2 = 2;
        const q3 = 3;
        const q4 = 4;
        const quarter = [q1, q2, q3, q4];
        const year = date.getFullYear();
        return [year, quarter[Math.floor(date.getMonth() / noOfMonthsInQuarter)]];
    }
    const [y, q] = getQuarter();
    let yr = y;
    const quarterArr = [];
    function getQuarterArr(year, qtr) {
        for (let i = qtr; i > 0 && quarterArr.length !== quarterArrLength; i -= 1) {
            quarterArr.push({ label: `Q${i} ${year}`, value: `q${i}_${year}` });
        }
    }
    getQuarterArr(y, q);
    while (quarterArr.length !== quarterArrLength) {
        const quarterArrIndex = 4;
        yr -= 1;
        getQuarterArr(yr, quarterArrIndex);
    }
    return { qtrList: quarterArr };
};

export const getQueryParams = (url = window.location.search) => {
    const search = url.includes('?') ? url.split('?')[1] : '';
    return (search && JSON.parse(
        `{"${search.replace(/&/g, '","').replace(/[=]/g, '":"')}"}`,
        (key, value) => (key === '' ? value : decodeURIComponent(value)),
    )) || '';
};

export const capitalizeFunc = val => val.charAt(0).toUpperCase() + val.slice(1);

export const withStateHandlers = (addCustomHandler, initialState = {}, props = {}) => {
    const enhancedUseState = reduce(
        initialState instanceof Function
            ? initialState(props)
            : initialState,
        (result, ele, key) => {
            const arr = useState(initialState[key]);
            return key ? merge(result, { [key]: arr[0], [`set${capitalizeFunc(key)}`]: arr[1] }) : result;
        },
        {},
    );
    const mergedProps = { ...props, ...enhancedUseState };
    const customHandler = addCustomHandler && addCustomHandler instanceof Function ? addCustomHandler(enhancedUseState, mergedProps) : {};
    return { ...mergedProps, ...customHandler };
};

export const getNodeMaxId = elements => {
    const nodes = elements.filter(e => (!e.source && !e.target));
    return Math.max(...nodes.map(e => Number(e.id.split('_')[1])));
};

/* function to sort the array of objects considering null values */
export const sortIterate = (item, property) => {
    // Null will be returned for any undefined values
    const value = get(item, property, null);
    // If value is null set to empty string to get proper sort order
    // Works if comparing against strings, numbers, booleans, and dates.
    return value === null ? '' : value;
};

const personalDomains = [
    'gmail.com',
    'yahoo.com',
    'deloitte.com',
    'kpmg.com',
    'ey.com',
    'gt.com',
];

export const isValidDomain = email => {
    const domain = email.split('@')[1]?.toLowerCase();
    return personalDomains.includes(domain) ? domain : null;
};
